/**
 * Get the proper country name based on the provided country code.
 * @param {string} code
 * @param {string} [locale='en'] - optional language for the localized names
 * @returns {undefined|string}
 */
export function getCountryName(code, locale = 'en') {
  if (!code) {
    return;
  }
  const countryCode = String(code).trim().toUpperCase();
  return new Intl.DisplayNames([locale], { type: 'region' }).of(countryCode);
}
